import { render, staticRenderFns } from "./SendAnswerImage.vue?vue&type=template&id=1959ea98&scoped=true&"
import script from "./SendAnswerImage.vue?vue&type=script&lang=ts&"
export * from "./SendAnswerImage.vue?vue&type=script&lang=ts&"
import style0 from "./SendAnswerImage.vue?vue&type=style&index=0&id=1959ea98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959ea98",
  null
  
)

export default component.exports